<template>
	<!-- 分组数据 -->
	<div>
		<div v-if="list_files_group.length > 0 && groupItem.list.length > 0" class="my-upload-list"
			v-for="(groupItem, gindex) in list_files_group" :key="gindex">
			<div>
				<div v-if="isGroup" class="group-header">
					<div class="group-title">{{groupItem.group.name}}</div>
					<div>
						<button v-if="list_files_group.length > 1" :disabled="gindex == 0"
							:class="gindex == 0 ? 'file-group-not-allowed icon-btn' : 'file-group-pointer icon-btn'" type="button"
							@click="fileGroupSort(groupItem, 1, list_files_group, gindex)">上移</button>
						<button v-if="list_files_group.length > 1" :disabled="(gindex + 1) == list_files_group.length"
							:class="(gindex + 1) == list_files_group.length ? 'file-group-not-allowed icon-btn' : 'file-group-pointer icon-btn'"
							type="button"
							@click="fileGroupSort(groupItem, 2, list_files_group,gindex)">下移</button>
						<button v-if="groupItem.group.name != '未分组'"
							type="button"
							class="icon-btn"
							@click="updateGroupName(groupItem)">修改</button>
						<el-popconfirm cancel-button-type="Text" confirm-button-type="Text" :hide-icon="true" style="padding: 0;"
							width="250" placement="bottom-end" @onConfirm='resettingFileGroup(groupItem, list_files_group)'
							title="确定解散该分组？">
							<button v-show="groupItem.group.name!='未分组'" type="button"
								class="icon-btn icon-delete"
								slot="reference">解散</button>
						</el-popconfirm>
					</div>
				</div>
			</div>


			<div v-for="(item, index) in groupItem.list" :key="index" @mouseover="handleMouseOver(item)"
				@mouseleave="handleMouseLeave(item)">
				<div class="file-group-hover-background" v-if="item">
					<div class="file-row">
						<img :src="util.setFileIcon(item.path)" class='my-file'>
						<span class="file-name">{{ item.name }}({{ item.size }})</span>
					</div>
					<div style="flex-shrink: 0;">
						<button
							:key="item.hover + '-' + (item.id || item.uid || item.path)"
							v-if="isGroup && item.hover && !item.select"
							type="button"
							style="color: #FF6600;"
							@click="addGroupName(item,list_files_group)"
							class="mr-10 icon-btn"
						>
							<i class="el-icon-plus"></i>新建分组
						</button>

						<el-tooltip popper-class="tooltip-content" effect="dark" content="上移" placement="bottom">
							<button :disabled="index==0" element-loading-spinner="el-icon-loading" type="button"
								:class="['icon-btn', index==0?'file-group-not-allowed':'file-group-pointer']"
								@click="fileSort(item,1,groupItem.list,index)">
								<i class="el-icon-top"></i>
							</button>
						</el-tooltip>
						<el-tooltip  popper-class="tooltip-content" effect="dark" content="下移" placement="bottom">
							<button :disabled="(index+1)==groupItem.list.length"
								:class="['icon-btn', (index+1)==groupItem.list.length?'file-group-not-allowed':'file-group-pointer']"
								element-loading-spinner="el-icon-loading" type="button"
								@click="fileSort(item,2,groupItem.list,index)">
								<i class="el-icon-bottom"></i>
							</button>
						</el-tooltip>
						<el-tooltip popper-class="tooltip-content" effect="dark" content="预览" placement="bottom">
							<button element-loading-spinner="el-icon-loading" type="button"
								class="icon-btn"
								@click="showFile(item.path)">
								<i class="el-icon-zoom-in"></i>
							</button>
						</el-tooltip>
						<el-tooltip popper-class="tooltip-content" effect="dark" content="修改名称" placement="bottom">
							<button element-loading-spinner="el-icon-loading" type="button"
								class="icon-btn"
								@click="updateList(item)">
								<i class="el-icon-edit-outline"></i>
							</button>
						</el-tooltip>
						<el-tooltip popper-class="tooltip-content" effect="dark" content="删除" placement="bottom">
						<el-popconfirm cancel-button-type="Text" confirm-button-type="Text" :hide-icon="true"
							width="250" placement="bottom-end" @onConfirm='delList(item,groupItem.list,index)'
							title="确定删除该文件吗？" style="padding: 0;">
							<button slot="reference" element-loading-spinner="el-icon-loading" type="button" class="icon-btn icon-delete">
								<i class="el-icon-delete"></i>
							</button>
						</el-popconfirm>
						</el-tooltip>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="修改名称" :visible.sync="updateModel" width="600px" :close-on-click-modal="false" center>
			<div class="dialog-overflow">
				<div class="dialog-float-left">
					<el-input class="dialog-input" size='small' v-model="updateInput" placeholder="请输入内容"></el-input>
					<span v-if="!isUpdateGroup"> .{{getFileSuffix()}}</span>
				</div>
			</div>
			<span slot="footer">
				<button type="button" class="cancel-btn mr-10" @click="updateModel = false">取消</button>
				<button type="button" class="dark-btn" @click="updateSure">确定</button>
			</span>
		</el-dialog>
		<fileGroup @refreshData="refreshFileGroupData" :isUpdateGroup="isUpdateGroup" ref="fileGroup" />
	</div>
</template>

<script>
	import fileGroup from './fileGroupDialog.vue'
	export default {
		//isGroup 是否开启分组显示
		props: ['list_files_group', 'info_files', "isGroup"],
		components: {
			fileGroup
		},
		data() {
			return {
				listInfo: {},
				updateInput: "",
				updateModel: false,
				isUpdateGroup: false,
				filePath: ""
			}
		},
		watch: {
			list_files_group: {
				deep: true,
				immediate: true,
				handler(val) {
					// this.local_files_group = JSON.parse(JSON.stringify(val || [])); // Removed
				}
			},
			info_files: {
				deep: true,
				immediate: true,
				handler(val) {
					// this.local_info_files = JSON.parse(JSON.stringify(val || [])); // Removed
				}
			}
		},
		methods: {
			getFileSuffix() {
				var fileExtension = "";
				if (this.filePath) {
					fileExtension = this.filePath.split('.').pop();
				}
				return fileExtension
			},
			//删除
			delList(data, list, index) {
				list.splice(index, 1); //删除分组数据
				//后期观察一下数据是否有问题
				this.info_files.forEach((item, index) => {
					if (item.id == data.id) { //删除原数据
						this.info_files.splice(index, 1)
					}
				})
				console.log('group_list', this.list_files_group)
				console.log('info_files', this.info_files)
			},
			//分组排序 fileGroupSort  1上 2下
			fileGroupSort(data, sortType, groupList, index) {
				if (sortType === 1 && index > 0) {
					// 上移
					groupList[index - 1].group.weigh = data.group.weigh;
					data.group.weigh = data.group.weigh - 1;
				} else if (sortType === 2 && index < groupList.length - 1) {
					// 下移
					groupList[index + 1].group.weigh = data.group.weigh;
					data.group.weigh = data.group.weigh + 1;
				}

				groupList.sort((a, b) => a.group.weigh - b.group.weigh);

			},
			//文件排序
			fileSort(data, sortType, list, index) {
				if (sortType == 1) {
					list[index - 1].weigh = data.weigh
					data.weigh = data.weigh - 1
				} else {
					list[index + 1].weigh = data.weigh
					data.weigh = data.weigh + 1
				}
				list.sort((a, b) => a.weigh - b.weigh);

			},
			// 重置分组
			resettingFileGroup(groupItem, groupList) {
				// 拆散分组，将分组内的文件恢复到“未分组”，并移除原分组
				let itemData = JSON.parse(JSON.stringify(groupItem)); // 需要分解的分组数据
				if (itemData.list.length > 0) {
					// 1. 删除该分组
					let removeIdx = groupList.findIndex(item => item.group.name == itemData.group.name);
					if (removeIdx !== -1) {
						groupList.splice(removeIdx, 1);
					}

					// 2. 重置 info_files 中相关文件的 select/disabled 状态
					itemData.list.forEach(data => {
						let file = null;
						if (!data.id) {
							file = this.info_files.find(item => !item.id && item.path == data.path);
						} else {
							file = this.info_files.find(item => item.uid == data.uid);
						}
						if (file) {
							this.$set(file, 'select', false);
							this.$set(file, 'disabled', false);
						}
					});

					// 3. 将分组内的文件合并到“未分组”，并重置select/disabled
					let unassignedGroup = groupList.find(item => item.group.name === "未分组");
					if (unassignedGroup) {
						// 先重置itemData.list中每个文件的select/disabled
						itemData.list.forEach(file => {
							file.select = false;
							file.disabled = false;
						});
						unassignedGroup.list = unassignedGroup.list.concat(itemData.list);
						unassignedGroup.list.sort((a, b) => a.weigh - b.weigh);
					} else {
						let dataInfo = {
							group: {
								name: "未分组",
								weigh: 0,
							},
							list: itemData.list.map(file => {
								return {
									...file,
									select: false,
									disabled: false
								}
							})
						};
						dataInfo.list.sort((a, b) => a.weigh - b.weigh);
						groupList.push(dataInfo);
					}
				}
			},
			//数据分组
			refreshFileGroupData(data) {
				let selectList = []; //已分组数据
				let selecrNList = []; //未勾选
				this.info_files.forEach(item => {
					if (item.select && !item.disabled) {
						selectList.push(item)
					} else if (!item.select) {
						selecrNList.push(item)
					}
				})

				//查询该分组是否已经存在，如果存在就把新的数据更新
				let selectGroupName = false;
				this.list_files_group.forEach(item => {
					if (item.group.name == "未分组") {
						item.list = selecrNList;
					} else if (item.group.name == data.name) { // 已存在
						item.list = selectList;
						selectGroupName = true;
					}

				});

				if (!selectGroupName) { // 新分组
					let groupInfo = {
						group: {
							name: data.name,
							weigh: 0,
						}

					};
					groupInfo.list = selectList;
					this.list_files_group.unshift(groupInfo);
				}
				//如果分组数据的list没数据需要清理掉
				this.list_files_group.forEach((item, index) => {
					if (item.group.name == "未分组") {
						if (item.list.length == 0) {
							this.list_files_group.splice(index, 1)
						}
					}

				});


			},
			//新建分组
			addGroupName(data, groupList) {
				data.hover = false
				groupList.forEach(item => {
					if (item.group.name !== "未分组") {
						let list = item.list;
						this.info_files.forEach(file => {
							let match = list.find(item => item.id === file.id);
							if (match) {
								file.select = true;
								file.disabled = true
							}
						});
					}
				});
				this.$refs.fileGroup.show(data, this.info_files, this.list_files_group)
			},
			handleMouseOver(hItem) {
				this.list_files_group.forEach(item => {
					item.list.forEach(data => {
						this.$set(data, 'hover', false)
					})
				})
				this.list_files_group.forEach(item => {
					item.list.forEach(data => {
						if ((hItem.id && data.id && hItem.id == data.id) || (hItem.uid && data.uid && hItem
								.uid == data.uid) || hItem.path == data.path) {
							this.$set(data, 'hover', true)
						}
					})
				})
			},
			handleMouseLeave(hItem) {
				this.list_files_group.forEach(item => {
					item.list.forEach(data => {
						if ((hItem.id && data.id && hItem.id == data.id) || (hItem.uid && data.uid && hItem
								.uid == data.uid) || hItem.path == data.path) {
							this.$set(data, 'hover', false)
						}
					})
				})

			},
			showFile(path) {
				// this.$refs.Showfile.preview(path)
			},
			//编辑
			updateList(val) {
				this.listInfo = val
				this.updateInput = val.name
				this.updateModel = true
				this.isUpdateGroup = false
				this.filePath = val.path
			},
			//修改
			updateSure() {
				if (this.isUpdateGroup) {
					if(!this.updateInput){
						this.$message({
							message: '请输入分组名称！',
							type: 'error'
						});
						return
					}
					if(this.updateInput.length>15){
						this.$message({
							message: '分组名称不能超过15个字符！',
							type: 'error'
						});
						return
					}
					this.listInfo.group.name = this.updateInput
					this.updateModel = false
				} else {
					if(!this.updateInput){
						this.$message({
							message: '请输入名称！',
							type: 'error'
						});
						return
					}
					this.listInfo.name = this.updateInput
					this.updateModel = false
				}
				
			},
			//修改组名
			updateGroupName(val) {
				this.listInfo = val
				this.isUpdateGroup = true
				this.updateInput = val.group.name
				this.updateModel = true
			},
		},
		mounted() {


		},
	}
</script>

<style>
	.tooltip-content {
		background: #CECECE !important;
		color: #3D3D3DFF !important;
		border: 1px solid #CECECE !important;
		padding-top: 6px;
		padding-bottom: 6px;
	}

	.tooltip-content[x-placement^="bottom"] .popper__arrow {
		border-bottom-color: #CECECE !important;
		opactity: 1;
		margin-bottom: 1px !important;
	}

	.tooltip-content[x-placement^="bottom"] .popper__arrow:after {
		border-bottom-color:#CECECE !important;
		opactity: 1;
		margin-bottom: 1px !important;
	}
</style>

<style lang="scss" scoped>
	.file-group-hover-background {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		&:hover {
		background-color: #F7F7F7;
		}
	}

	.my-upload-list>div {
		margin-bottom: 0px;
	}

	.my-upload-list>div>div:nth-of-type(1) {
		height: 44px;
	}

	.file-group-pointer {
		cursor: pointer;
		color: var(--cs-theme-background-color);
	}

	.file-group-not-allowed {
		cursor: not-allowed !important;
		color: #999999FF !important;
	}

	// 新增优化样式
	.group-header {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.group-title {
		font-size: 14px;
		color: #666666;
		font-weight: 400;
	}
	.file-row {
		max-width: 350px;
		display: flex;
		align-items: center;
	}
	.file-name {
		max-width: 350px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		padding: 0;
	}
	.mr-10 {
		margin-right: 10px;
	}
	.dialog-overflow {
		overflow: hidden;
	}
	.dialog-float-left {
		float: left;
	}
	.dialog-input {
		width: 508px;
	}
	.icon-btn {
		height: 33px;
		border-radius: 5px;
		padding: 10px 5px;
		font-size: 14px;
		color: #666;
		background: #f5f5f5;
		border: none;
		display: inline-flex;
		align-items: center;
		transition: background 0.2s;
		margin-right: 5px;
		cursor: pointer;
		&:hover {
			background: #ececec;
		}
	}
	.icon-delete {
		color: #fff;
		background: #ff4d4f;
		&:hover {
			background: #ff7875;
		}
	}
</style>